import { Box } from '@mui/material';
import { useActivityShopUI } from 'hooks/useActivityShopUI';
import { ActivityInteractionData } from "interfaces/ActivityShopUIInterfaces";
import { useLocalization } from 'hooks/useLocalization';

import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import './style.css';
import CollapsedAlert from 'components/shared/CollapsedAlert';

interface ActivityDatePickerPrivateProps {
	activityId: number;
	activityInteractionData: ActivityInteractionData;
	todayDate: Date;
}

function ActivityDatePickerPrivate({ activityId, activityInteractionData, todayDate }: ActivityDatePickerPrivateProps) {
	const { updateActivityDate } = useActivityShopUI();
	const { getStr } = useLocalization();
	const selectedDate = activityInteractionData.dateSelected.private;

	const handleDateChange = (newDate: Date | undefined) => {
		updateActivityDate(
			activityId,
			'private',
			newDate
		);
	};
	
	function getDisabledDates(date: Date) {
		// Disable dates in the past
		if (activityInteractionData.isAdded) {
			return true;
		}

		if (date < todayDate) {
			return true;
		}

		return false;
	}
	
	return (
		<>
			<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', marginBottom: '30px' }}>
				<div className="activity-calendar-wrapper">
					<DayPicker
						mode="single"
						selected={selectedDate}
						onSelect={handleDateChange}
						defaultMonth={selectedDate}
						weekStartsOn={1}
						fromMonth={todayDate}
						disabled={getDisabledDates}
					/>
				</div>
			</Box>
			<CollapsedAlert isVisible={!selectedDate} severity="error">
				{getStr('Please_select_a_date')}
			</CollapsedAlert>
		</>
	);
}

export default ActivityDatePickerPrivate;